import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";

import "./styles/fonts.css";
import "./styles/styles.css";

const App = () => {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
      </Routes>
    </>
  );
}

export default App;
